module.exports = __webpack_public_path__ + "static/media/send_white_24dp.9f9b01f2.svg";